import { useMemo } from "react"
import { useQuery } from "urql"

import { GetBaseWarehouseListDocument, type WarehouseAreaOutputList } from "@/graphql/codegen/graphql"
import type { Option } from "@/types/form-fields"
import { getWarehouseOptions } from "@/utils/warehouse"

interface UseGetWarehouseOptionsParams {
  isActive?: boolean
  isInventoryRelated?: boolean
}

interface UseGetWarehouseOptionsReturn {
  warehouseOptions: Option<string>[]
  isFetching: boolean
}

export const useGetWarehouseOptions = ({
  isActive,
  isInventoryRelated,
}: UseGetWarehouseOptionsParams = {}): UseGetWarehouseOptionsReturn => {
  const [{ data, fetching }] = useQuery({
    query: GetBaseWarehouseListDocument,
    variables: {
      input: {
        filter: { isActive, isInventoryRelated },
        offset: 0,
        limit: 100,
      },
    },
  })

  const warehouseOptions = useMemo((): Option<string>[] => {
    const result = data?.warehouseArea?.list

    if (result?.__typename === "WarehouseAreaListSuccess") {
      return getWarehouseOptions(result.warehouseAreas as WarehouseAreaOutputList[])
    }

    return []
  }, [data])

  return { warehouseOptions, isFetching: fetching }
}
